// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InfoBox_wrapper_3lPlR","info":"InfoBox_info_llOYc","icon":"InfoBox_icon_rPJJF"};